export enum Team {
  Red = 'team-red',
  Blue = 'team-blue',
}

export interface TeamMetadata {
  color: string;
}

export const TEAM_METADATA: Record<Team, TeamMetadata> = {
  [Team.Blue]: {color: '#3484FC'},
  [Team.Red]: {color: '#FF5A5A'},
};
